"use client";

import { c as _c } from "react/compiler-runtime";
import type { AssistantRouteContext } from "@agroproj/backend/convex/assistant/routeContext";
import { BotIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { subsectionTitleClassName } from "@/components/ui/typography";
import { getAssistantSuggestions } from "@/lib/assistant/suggestions";
import { cn } from "@/lib/utils";
type AssistantSuggestionsProps = {
  context: AssistantRouteContext;
  onPrompt: (prompt: string) => void;
};

/** Starter prompts for the assistant, scoped to the current route context. */
export function AssistantSuggestions(t0) {
  const $ = _c(16);
  const {
    context,
    onPrompt
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== context || $[1] !== onPrompt) {
    const suggestions = getAssistantSuggestions(context);
    t3 = "flex flex-col gap-3";
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <h3 className={cn(subsectionTitleClassName, "flex items-center gap-2")}><BotIcon aria-hidden="true" className="text-muted-foreground size-4 shrink-0" />O que posso perguntar?</h3>;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t1 = "grid gap-2";
    let t5;
    if ($[7] !== onPrompt) {
      t5 = prompt => <Button className="h-auto min-h-8 justify-start py-1.5 text-left whitespace-normal" key={prompt} onClick={() => onPrompt(prompt)} size="sm" variant="outline">{prompt}</Button>;
      $[7] = onPrompt;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t2 = suggestions.map(t5);
    $[0] = context;
    $[1] = onPrompt;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2) {
    t5 = <div className={t1}>{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <section className={t3}>{t4}{t5}</section>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}